// extracted by mini-css-extract-plugin
module.exports = {"popup":"addquizform_popup__2aY6U","close_button":"addquizform_close_button__WQZPA","container":"addquizform_container__1aHgm","sub_container":"addquizform_sub_container__mLjEt"};